import monitorService from '@/services/monitor.service';
import { filterRulesMapped } from '@/tools/filterRules';
import { generalConfigurationService } from '../../services/generalConfiguration.service'
import { GENERAL_CONFIGURATIONS } from '@colven/common-domain-lib/lib'
import { NOTIFICATION_STATUS_HEADERS } from './constants';
import { SnackbarStyle, REGEX } from '@/constants/constants'
import { mapActions } from 'vuex'
import i18n from '@/i18n'
import moment from 'moment'

export default {
    name: "NotificationStatusComponent",
    components: {},
    data() {
        return {
            // reglas de validación
            validationRules: {                
                email: value => !value || REGEX.email.test(value.toString()) || `${i18n.t('user.invalidEmail')}`,
            },
            tableData: [],
            serverNotificationStatus: [],
            emailAddress: null,
            editingEmail: false,
            isValidEmail: false,
            tableDataKey: "id",
            tableHeaders: NOTIFICATION_STATUS_HEADERS,
            tableFilterRules: {},
            loading: false,
        };
    },
    async mounted() {
        this.loading = true;
        try {
            this.tableData.cleanAndUpdate([]);
            await this.getAlertEmailAddress();
            await this.refreshInfo();
            this.setTableFilterRules();
        } finally {
            this.loading = false;
        }
        this.unitIdInteval = setInterval(async () => {
            await this.refreshInfo();
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.unitIdInteval);
    },
    methods: {
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        async refreshInfo() {
            try {
                this.loading = true;
                await this.updateTable();
                await this.updateSummary();
            } finally {
                this.loading = false;
            }
        },

        async updateTable() {
            let data = await monitorService.getNotificationStatusData()
            if (data.length) {
                data.map(notification => {
                    notification.received_date = this.formatDate(notification.received_date)
                })
            }
            this.tableData.cleanAndUpdate(data);
        },
        async updateSummary() {
            const data = await monitorService.getServerStatusData();
            this.serverNotificationStatus = data;
        },
        formatDate(date) {
            return date ? moment(new Date(date)).format("DD-MM-YYYY HH:mm:ss") : ''
        },
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        async getAlertEmailAddress() {
            const result = await generalConfigurationService.getByKey(GENERAL_CONFIGURATIONS.NOTIFICATION_ALERT_EMAIL_ADDRESS)
            this.emailAddress = result;
        },
        async toggleEdit() {
            this.editingEmail = !this.editingEmail
        },
        async saveChangesOnEmail() {
            generalConfigurationService.setByKey(GENERAL_CONFIGURATIONS.NOTIFICATION_ALERT_EMAIL_ADDRESS, this.emailAddress).then(async () => {
                this.showSnackbar({
                    visible: true,
                    text: this.$t('notificationStatus.successUpdateMessage'),
                    timeout: 6000,
                    style: SnackbarStyle.SUCCESS
                })
            })
            this.toggleEdit();
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        emailAddress(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.isValidEmail = this.$refs.notificationForm.validate()
            }
        },
    }
};
